export default function Configuracoes() {
  return <h1>Configurações do Sistema</h1>;
}
